export default __webpack_public_path__ + "static/media/appsumo_hert.7440b89d.svg";